<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="搜索房型" style="width:220px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增房型</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="{ $index }">{{ (page - 1) * pageSize + $index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="name" label="房型名称" min-width="160" />
      <el-table-column label="工序数量" width="100" align="center">
        <template slot-scope="{ row }">{{ row.stageCount != null ? row.stageCount : 0 }}</template>
      </el-table-column>
      <el-table-column label="工期天数" width="100" align="center">
        <template slot-scope="{ row }">{{ row.durationDays != null ? row.durationDays : 0 }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
      <el-table-column prop="enabled" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.enabled === 1 ? 'success' : 'info'">{{ row.enabled === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id ? '编辑房型' : '新增房型'" :visible.sync="visible" width="860px" top="5vh">
      <el-form :model="form" label-width="90px">
        <el-form-item label="房型名称" required>
          <el-input v-model="form.name" maxlength="64" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="工序" required>
          <div class="stage-toolbar">
            <el-button size="mini" type="primary" plain @click="addLine">添加工序</el-button>
            <el-button size="mini" plain @click="loadAllStages">加载全部工序</el-button>
            <el-button size="mini" type="danger" plain @click="clearAllStages">全部删除</el-button>
            <span class="hint">工期按「第几天～第几天」填写，可重叠/穿插</span>
          </div>
          <el-table :data="form.stages" border size="small">
            <el-table-column label="工序" min-width="180">
              <template slot-scope="{ row }">
                <el-select v-model="row.stageDefId" filterable placeholder="选择工序" style="width:100%">
                  <el-option v-for="s in stageOptions" :key="s.id" :label="s.name" :value="s.id" />
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="排序" width="150">
              <template slot-scope="{ row }">
                <el-input-number v-model="row.sortNo" :min="0" :max="9999" size="mini" controls-position="right" />
              </template>
            </el-table-column>
            <el-table-column label="工期" min-width="260">
              <template slot-scope="{ row }">
                <span class="day-wrap">
                  第
                  <el-input-number v-model="row.startDay" :min="1" :max="9999" size="mini" controls-position="right" />
                  天 —
                  第
                  <el-input-number v-model="row.endDay" :min="1" :max="9999" size="mini" controls-position="right" />
                  天
                </span>
              </template>
            </el-table-column>
            <el-table-column label="" width="70">
              <template slot-scope="{ $index }">
                <el-button type="text" style="color:#ef4444" @click="form.stages.splice($index,1)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listHouseTypes, getHouseType, saveHouseType, deleteHouseType, listStageDefs } from '../../api/project'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'HouseType',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      keyword: '',
      list: [],
      stageOptions: [],
      loading: false,
      visible: false,
      saving: false,
      form: { id: null, name: '', enabled: 1, remark: '', stages: [] }
    }
  },
  created() {
    this.loadStages()
    this.load()
  },
  methods: {
    async loadStages() {
      const res = await listStageDefs({})
      this.stageOptions = (res.data || []).filter(s => s.enabled !== 0)
    },
    async load() {
      this.loading = true
      try {
        const res = await listHouseTypes({ keyword: this.keyword })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    blankLine(stageDefId, sortNo) {
      return {
        stageDefId: stageDefId || null,
        sortNo: sortNo == null ? (this.form.stages.length + 1) * 10 : sortNo,
        startDay: undefined,
        endDay: undefined
      }
    },
    addLine() {
      this.form.stages.push(this.blankLine())
    },
    async loadAllStages() {
      await this.loadStages()
      if (!this.stageOptions.length) {
        return this.$message.warning('暂无可用工序，请先在工序模板中配置')
      }
      const exist = new Set((this.form.stages || []).map(s => s.stageDefId).filter(Boolean))
      let sort = (this.form.stages.length + 1) * 10
      const append = []
      this.stageOptions.forEach(s => {
        if (exist.has(s.id)) return
        append.push(this.blankLine(s.id, sort))
        sort += 10
      })
      if (!append.length) {
        return this.$message.info('已全部加载，无新增工序')
      }
      this.form.stages = this.form.stages.concat(append)
      this.$message.success('已加载 ' + append.length + ' 个工序')
    },
    clearAllStages() {
      if (!this.form.stages.length) return
      this.$confirm('确认清空全部工序？', '提示', { type: 'warning' })
        .then(() => {
          this.form.stages = []
        })
        .catch(() => {})
    },
    async openEdit(row) {
      await this.loadStages()
      if (!row) {
        this.form = { id: null, name: '', enabled: 1, remark: '', stages: [] }
        this.visible = true
        return
      }
      const res = await getHouseType(row.id)
      const d = res.data || {}
      this.form = {
        id: d.id,
        name: d.name,
        enabled: d.enabled,
        remark: d.remark,
        stages: (d.stages || []).map(s => ({
          stageDefId: s.stageDefId,
          sortNo: s.sortNo,
          startDay: s.startDay,
          endDay: s.endDay
        }))
      }
      this.visible = true
    },
    async save() {
      if (!this.form.name) return this.$message.warning('请填写房型名称')
      if (!this.form.stages.length) return this.$message.warning('请配置工序')
      if (this.form.stages.some(s => !s.stageDefId)) return this.$message.warning('请选择工序')
      for (const s of this.form.stages) {
        if (s.startDay == null || s.endDay == null) {
          return this.$message.warning('请填写每道工序的起止天数')
        }
        if (Number(s.startDay) > Number(s.endDay)) {
          return this.$message.warning('开始天数不能大于结束天数')
        }
      }
      this.saving = true
      try {
        await saveHouseType(this.form)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    onDelete(row) {
      this.$confirm(`确认删除房型「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteHouseType(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.stage-toolbar { margin-bottom:8px; display:flex; flex-wrap:wrap; gap:8px; align-items:center; }
.hint { color:#94a3b8; font-size:12px; margin-left:4px; }
.day-wrap {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  font-size: 12px;
  color: #64748b;
}
.day-wrap .el-input-number { width: 100px; }
</style>
